<template>
  <div v-if="showBreadcrumb" class="kima-breadcrumb">
    <div class="container">
      <a-breadcrumb>
        <a-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index">
          <router-link v-if="item.key" :to="item.key">
            {{ $t(item.value) }}
          </router-link>

          <span v-else>
            {{ $t(item.value) }}
          </span>
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useRoute } from "vue-router"

const route = useRoute()

type BreadcrumbItem = {
  key?: string,
  value: string
}

const isHome = computed(() => {
  const path = (route.path || '/').replace(/\/+$/, '') || '/'
  return path === '/' || path === ''
})

const breadcrumbs = computed<BreadcrumbItem[]>(() => {
  return (route.meta?.breadcrumb as BreadcrumbItem[]) || []
})

const showBreadcrumb = computed(() => {
  return !isHome.value && breadcrumbs.value.length > 0
})
</script>

<style scoped>
.kima-breadcrumb {
  /* background-color: color-mix(in srgb, var(--default-color), transparent 95%); */
  padding: 20px 0;
}

.kima-breadcrumb :deep(.ant-breadcrumb) {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
}

.kima-breadcrumb :deep(.ant-breadcrumb a) {
  color: var(--default-color);
  transition: 0.3s;
}

.kima-breadcrumb :deep(.ant-breadcrumb a:hover) {
  color: var(--nav-hover-color);
}

.kima-breadcrumb :deep(.ant-breadcrumb-separator) {
  color: color-mix(in srgb, var(--default-color), transparent 70%);
  margin: 0 10px;
}

.kima-breadcrumb :deep(.ant-breadcrumb > span:last-child .ant-breadcrumb-link) {
  color: color-mix(in srgb, var(--default-color), transparent 40%);
}
</style>